import React from 'react';

/**
 * Composant de bannière publicitaire - DÉSACTIVÉ
 * La publicité est désactivée pour offrir une meilleure expérience utilisateur
 */
export default function AdBanner() {
  // Publicité désactivée - ne rien afficher
  return null;
}
